import React from 'react'

/**
 * Permet de split l'information sur le format
 * @param information
 * return
 */
export const displayHiresQuality = (information) => {
	let tabTechnicalSpecification = [' ', ' ']
	const technicalSpecification = information
	if (technicalSpecification) {
		tabTechnicalSpecification = information.split('/')
	}
	return <span>{tabTechnicalSpecification[0]}<br />{tabTechnicalSpecification[1]}</span>
}

/**
 * Affiche la qualité CD
 * (temporaire en attendant la remontée par l'API du champ maximum_technical_specification
 */
export const displayCdQuality = (bitDepth, samplingRate, channelCount) => {
	let channelLabel = ''
	switch (channelCount) {
		case 1:
			channelLabel = 'Mono'
			break
		case 2:
			channelLabel = 'Stereo'
			break
		case 6:
			channelLabel = 'Multicanal 5.1'
			break
		default:
			channelLabel = ''
			break
	}

	return <span>{`${bitDepth}-Bit CD Quality`}<br />{`${samplingRate} kHz - ${channelLabel}`}</span>
}

export const displayReleasedDate = (date, intl) => {
	return date ? new Date(`${date}T00:00:00`).toLocaleString(intl.locale, { year: 'numeric', month: 'long', day: 'numeric' }) : ''
}



// WEBPACK FOOTER //
// ./src/utils/display.js